module.exports = __webpack_public_path__ + "img/title-bg.8951b088.png";